import { BoostProvider, BoostTask } from "../../types/boost";
import { PROVIDERS } from "../../constants/providers";
import createAdHandler from "monetag-tg-sdk";

interface MonetagAdEvent {
  reward_event_type: "valued" | string;
}

export class MonetagBoostProvider implements BoostProvider {
  private adHandler: () => Promise<MonetagAdEvent>;

  constructor() {
    this.adHandler = createAdHandler(
      9421495
    ) as unknown as () => Promise<MonetagAdEvent>;
  }

  getName(): string {
    return PROVIDERS.MONETAG;
  }

  async getAvailableTasks(): Promise<BoostTask[]> {
    try {
      if (!window.initCdTma) {
        return [];
      }

      return [
        {
          id: "9421495",
          title: "Показать рекламу",
          description: "Просмотр рекламы Monetag",
          provider: PROVIDERS.MONETAG,
          onClick: async (): Promise<
            "success" | "user_cancelled" | "ads_not_found"
          > => {
            try {
              const event = await this.adHandler();

              if (event.reward_event_type === "valued") {
                return "success";
              } else {
                return "ads_not_found";
              }
            } catch (err) {
              console.error("Ошибка показа Monetag рекламы:", err);
              return "ads_not_found";
            }
          },
        },
      ];
    } catch (error) {
      console.error("Ошибка получения заданий Monetag:", error);
      return [];
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async startTask(
    _taskId: string | number
  ): Promise<"success" | "user_cancelled" | "ads_not_found"> {
    return "success";
  }
}
